import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from "@material-ui/core";
import t from "../../../languages/pl";
import CancelAcceptForm from '../../../components/Common/CancelAcceptForm';
import { KeyboardTimePicker, TimePicker, TimePickerView  } from "@material-ui/pickers";
import ScheduleIcon from '@material-ui/icons/Schedule';
import moment from 'moment-timezone';
import {displayTimeWithoutSecondsFormat } from './../../../utils/staticData';
import { selectConditionDescription } from './../../../utils/helpers';
import TextField from "@material-ui/core/TextField";
import Input from '@material-ui/core/Input';

const useStyles = theme => ({
    content: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: theme.spacing(3)
    },
    row: {
        paddingTop: theme.spacing(2),
        paddingRight: theme.spacing(4),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        overflow: "hidden"
    },
    startTimeRow: {
        margin: theme.spacing(1),
        display: "flex",
        alignItems: "center",
        overflow: "hidden"
    },
    centeredRow: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden"
    },
    textField: {
        margin: theme.spacing(1),
        width: 200
    },
    timePicker: {
        marginLeft: theme.spacing(2)
    }
});

const readOnlyTextField ={
    readOnly: true
};

const TextFieldComponent = (props) => {
    return <TextField {...props} inputProps={readOnlyTextField} />;
};

const ConditionsDialog = props => {
    const { classes, typeId, open, onClose,  onSelectFile, fileName,
        onSubmit7TypeId, onSubmit25TypeId, onSubmit26TypeId, onSubmit30TypeId,
        kilometersLimit, startTime, endTime } = props;
    const [description, setDescription] = useState("");
    const [selectedStartTime, setSelectedStartTime] = useState(0);
    const [selectedEndTime, setSelectedEndTime] = useState(0);
    const [selectedKilometersLimit, setSelectedKilometersLimit] = useState(0);
    const [layover, setLayover] = useState(0);
    const [file, setFile] = useState(null);

    useEffect(() => {
        setSelectedKilometersLimit(kilometersLimit);
    }, [kilometersLimit]);

    useEffect(() => {
        setSelectedStartTime(startTime);
    }, [startTime]);

    useEffect(() => {
        if (typeId) {
            setDescription(selectConditionDescription(typeId));
        }
    }, [typeId]);

    useEffect(() => {
        if (startTime) {
            setSelectedStartTime(startTime);
        }
    }, [startTime]);

    useEffect(() => {
        if (endTime) {
            setSelectedEndTime(endTime);
        }
    }, [endTime]);

    const handleStartTimeChange = (e) => {
        setSelectedStartTime(moment(e).unix());
    };

    const handleEndTimeChange = (e) => {
        setSelectedEndTime(moment(e).unix());
    };

    const selectFile = (e) => {
        e.preventDefault();
        const selectedFile = new FormData();
        selectedFile.append('file', e.target.files[0]);
        onSelectFile(e.target.files[0].name);
        setFile(selectedFile);
    };

    const handleSubmit = () => {
        if (onSubmit7TypeId && typeId === 7) {
            onSubmit7TypeId(file);
        }
        if (onSubmit25TypeId && typeId === 25) {
            onSubmit25TypeId(selectedStartTime.toString());
        }
        if (onSubmit26TypeId && typeId === 26) {
            onSubmit26TypeId(selectedStartTime.toString() + ";" + selectedEndTime.toString() + ";" + layover);
        }
        if (onSubmit30TypeId && typeId === 30) {
            onSubmit30TypeId(selectedKilometersLimit);
        }
        onClose();
    };

    return (
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth="sm"
            onClose={onClose}
        >
            <DialogTitle>
                {t.conditions}
            </DialogTitle>
            <DialogContent className={classes.content}>
                <Typography variant="subtitle1">
                    {description}
                </Typography>
            </DialogContent>
            <DialogContent>
                {typeId === 7 ?
                    <div className={classes.centeredRow}>
                        <Button
                            variant="contained"
                            color="primary"
                            component="label"
                        >
                            {t.selectFile}
                            <input
                                type="file"
                                style={{ display: "none" }}
                                onChange={selectFile}
                            />
                        </Button>
                        <TextField
                            value={fileName}
                            type="text"
                            disabled
                            label={t.fileName}
                            className={classes.textField}
                        />
                    </div>
                    : null
                }

                {typeId === 25 ?
                    <div className={classes.centeredRow}>
                        <KeyboardTimePicker
                            className={classes.timePicker}
                            label={t.workStartTime}
                            TextFieldComponent={TextFieldComponent}
                            ampm={false}
                            variant="inline"
                            invalidDateMessage={t.invalidTimeFormat}
                            format={displayTimeWithoutSecondsFormat}
                            placeholder={"__:__"}
                            keyboardIcon={<ScheduleIcon />}
                            value={moment.unix(selectedStartTime)}
                            onChange={handleStartTimeChange}
                        />
                    </div>
                    : null
                }

                {typeId === 26 ?
                    <React.Fragment>
                        <div className={classes.row}>
                            <Typography
                                variant="body1"
                            >
                            </Typography>
                            <KeyboardTimePicker
                                //className={classes.timePicker}
                                label={t.workStartTime}
                                TextFieldComponent={TextFieldComponent}
                                ampm={false}
                                variant="inline"
                                format={displayTimeWithoutSecondsFormat}
                                placeholder={"__:__"}
                                invalidDateMessage={t.invalidTimeFormat}
                                keyboardIcon={<ScheduleIcon />}
                                value={moment.unix(selectedStartTime)}
                                onChange={handleStartTimeChange}
                            />
                            <KeyboardTimePicker
                                //className={classes.timePicker}
                                TextFieldComponent={TextFieldComponent}
                                label={t.workFinishTime}
                                ampm={false}
                                variant="inline"
                                invalidDateMessage={t.invalidTimeFormat}
                                keyboardIcon={<ScheduleIcon />}
                                format={displayTimeWithoutSecondsFormat}
                                placeholder={"__:__"}
                                value={moment.unix(selectedEndTime)}
                                onChange={handleEndTimeChange}
                            />
                        </div>
                        <div className={classes.centeredRow}>
                            <TextField
                                value={layover}
                                type="number"
                                label={t.layoverTimeInHours}
                                className={classes.textField}
                                InputProps={{ inputProps: { min: 0, max: 12 } }}
                                //name="klient_limitkm"
                                onChange={(e) => setLayover(e.target.value)}
                            />
                        </div>
                    </React.Fragment>
                    : null
                }

                {typeId === 30 ?
                    <div className={classes.centeredRow}>
                        <TextField
                            value={selectedKilometersLimit}
                            type="number"
                            label={t.kilometersLimit}
                            className={classes.textField}
                            InputProps={{ inputProps: { min: 0 } }}
                            //name="klient_limitkm"
                            onChange={(e) => setSelectedKilometersLimit(e.target.value)}
                        />
                    </div>
                    : null
                }
            </DialogContent>
            <DialogActions>
                <CancelAcceptForm
                    onCancel={onClose}
                    acceptName={typeId === 7 ? t.send : null}
                    onSubmit={handleSubmit}
                    disableSubmit={isNaN(selectedStartTime) || isNaN(selectedEndTime) || (typeId === 7 && fileName === "")}
                />
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(useStyles)(ConditionsDialog);

ConditionsDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    typeId: PropTypes.number,
    startTime: PropTypes.number,
    endTime: PropTypes.number,
    kilometersLimit: PropTypes.number,
    onStartTimeChange: PropTypes.func,
    onEndTimeChange: PropTypes.func,
    onSubmit7TypeId: PropTypes.func,
    onSubmit26TypeId: PropTypes.func,
    onSubmit25TypeId: PropTypes.func,
    onSubmit30TypeId: PropTypes.func,
    onSelectFile: PropTypes.func,
    fileName: PropTypes.string,
};